import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = {
  key: 0,
  class: "space-y-6 p-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_DirectoryHeader = _resolveComponent("DirectoryHeader")!
  const _component_ErrorDisplay = _resolveComponent("ErrorDisplay")!
  const _component_DirectoryLayoutCard = _resolveComponent("DirectoryLayoutCard")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_DirectoryCodeModal = _resolveComponent("DirectoryCodeModal")!
  const _component_CreateNewDirectoryLayoutModal = _resolveComponent("CreateNewDirectoryLayoutModal")!
  const _component_DeleteConfirmationModal = _resolveComponent("DeleteConfirmationModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_LoadingSpinner, {
      isLoading: _ctx.isLoading || _ctx.isLoadingExperts
    }, null, 8, ["isLoading"]),
    _createVNode(_component_DirectoryHeader, {
      directoryLayoutsAvailable: _ctx.directoryLayoutsAvailable,
      onCreateNew: _ctx.openCreateNewDirectoryLayoutModal
    }, null, 8, ["directoryLayoutsAvailable", "onCreateNew"]),
    _createVNode(_component_ErrorDisplay, { errorMessage: _ctx.errorMessage }, null, 8, ["errorMessage"]),
    (_ctx.directoryLayoutsAvailable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.directoryLayouts, (layout) => {
            return (_openBlock(), _createBlock(_component_DirectoryLayoutCard, {
              key: layout.id,
              layout: layout,
              expandedLayoutId: _ctx.expandedLayoutId,
              profiles: _ctx.profiles,
              approvedExperts: _ctx.approvedExperts,
              userStore: _ctx.userStore,
              fieldErrors: _ctx.fieldErrors,
              updateDirectoryLoading: _ctx.updateDirectoryLoading,
              onShowCode: _ctx.showCodeModal,
              onToggleExpanded: _ctx.toggleLayoutExpanded,
              onDelete: _ctx.deleteLayout,
              onUpdate: _ctx.updateLayout,
              onCancelEdit: _ctx.cancelEdit,
              onUpdateLayoutName: _ctx.updateLayoutName,
              onUpdateLayoutType: _ctx.updateLayoutType,
              onUpdateLayoutStyle: _ctx.updateLayoutStyle,
              onUpdateLayoutCosmetic: _ctx.updateLayoutCosmetic,
              onUpdateLayoutHeader: _ctx.updateLayoutHeader,
              onUpdateLayoutWebsite: _ctx.updateLayoutWebsite,
              onUpdateLayoutSearchFilters: _ctx.updateLayoutSearchFilters,
              onUpdateLayoutSelectedExperts: _ctx.updateLayoutSelectedExperts,
              onUpdateLayoutRandomExperts: _ctx.updateLayoutRandomExperts
            }, null, 8, ["layout", "expandedLayoutId", "profiles", "approvedExperts", "userStore", "fieldErrors", "updateDirectoryLoading", "onShowCode", "onToggleExpanded", "onDelete", "onUpdate", "onCancelEdit", "onUpdateLayoutName", "onUpdateLayoutType", "onUpdateLayoutStyle", "onUpdateLayoutCosmetic", "onUpdateLayoutHeader", "onUpdateLayoutWebsite", "onUpdateLayoutSearchFilters", "onUpdateLayoutSelectedExperts", "onUpdateLayoutRandomExperts"]))
          }), 128))
        ]))
      : (_openBlock(), _createBlock(_component_EmptyState, {
          key: 1,
          onCreateNew: _ctx.openCreateNewDirectoryLayoutModal
        }, null, 8, ["onCreateNew"])),
    _createVNode(_component_DirectoryCodeModal, {
      isVisible: _ctx.isCodeModalVisible,
      companyId: _ctx.companyId,
      programUuid: _ctx.programUuid,
      layoutId: _ctx.selectedLayoutId,
      onCloseCodeModal: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isCodeModalVisible = false))
    }, null, 8, ["isVisible", "companyId", "programUuid", "layoutId"]),
    _createVNode(_component_CreateNewDirectoryLayoutModal, {
      isVisible: _ctx.isCreateNewDirectoryLayoutModalVisible,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isCreateNewDirectoryLayoutModalVisible = false)),
      onCreateLayout: _ctx.handleCreateLayout
    }, null, 8, ["isVisible", "onCreateLayout"]),
    (_ctx.showDeleteConfirmation && _ctx.selectedLayoutToDelete)
      ? (_openBlock(), _createBlock(_component_DeleteConfirmationModal, {
          key: 2,
          layoutId: _ctx.selectedLayoutToDelete,
          layoutName: _ctx.selectedLayoutName,
          onDeleted: _ctx.handleLayoutDeleted,
          onClose: _ctx.cancelDelete
        }, null, 8, ["layoutId", "layoutName", "onDeleted", "onClose"]))
      : _createCommentVNode("", true)
  ]))
}